import {
    TASK_SUM_REQUEST,
    TASK_SUM_SUCCESS,
    TASK_SUM_FAIL,
    ACCOUNTANT_TASK_SUCCESS,
    COMPANY_TASK_SUCCESS,
    MANAGER_TASK_SUCCESS,
    GET_TASK_SUCCESS,
    GET_TASK_REQUEST,
    ADD_TASK_LOCAL
} from '../actions/task.js';


const initialState = {
    taskDurStatus: 'request',
    taskStatus: 'request',
    tasks: [],
    company: {},
    duration:{},
    accountant:[],
    companies:[],
    managers:[],
    taskMessage : {}
};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case TASK_SUM_REQUEST: {
            return {
                ...state,
                taskDurStatus: 'request',
            };
        }
        case TASK_SUM_SUCCESS: {
            return {
                ...state,
                taskDurStatus: 'ok',
                duration:action.payload.data
            };
        }
        case ACCOUNTANT_TASK_SUCCESS: {
            return {
                ...state,
                accountant:action.payload.data
            };
        }
        case COMPANY_TASK_SUCCESS: {
            return {
                ...state,
                companies:action.payload.data.companies
            };
        }
        case MANAGER_TASK_SUCCESS: {
            return {
                ...state,
                managers:action.payload.data.results
            };
        }
        case TASK_SUM_FAIL: {
            return {
                ...state,
                taskDurStatus: 'fail',
            };
        }
        case GET_TASK_SUCCESS: {
            return {
                ...state,
                taskStatus: 'success',
                tasks:action.payload.data

            };
        }
        case ADD_TASK_LOCAL: {
            return {
                ...state,
                taskMessage: action.payload.data
            };
        }
        case GET_TASK_REQUEST: {
            return {
                ...state,
                taskStatus: 'request',
            };
        }



        default: {
            return {
                ...state,
            };
        }
    }
}
